import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable, Subject } from 'rxjs';

import { $digitalPropertyMonitoring } from '../../../../../../../shared/constants/digital-properties';
import {
  AuditToolCommonNames,
  AuditToolCommonNamesToAuditToolNames,
  AuditToolNames,
} from '../../../../../../../shared/constants/audit-tool';
import { standardNameAndLevel } from '../../../../../../../shared/constants/scanning';
import { IDigitalPropertyMonitoringDetails } from '../../../../../../../shared/interfaces/digital-property.interface';
import { A11yStandardsService } from '../../../../../services/a11y-standards/a11y-standards.service';

@Component({
  selector: 'app-monitoring-scan-settings-step',
  templateUrl: './monitoring-scan-settings-step.component.html',
  styleUrls: ['./monitoring-scan-settings-step.component.scss'],
  standalone: false,
})
export class MonitoringScanSettingsStepComponent implements OnInit, AfterViewInit {
  public a11yStandards$: Observable<standardNameAndLevel[]>;
  public $digitalPropertyMonitoring: typeof $digitalPropertyMonitoring;

  @Input() public stepNumber: number;
  @Input() public form: UntypedFormGroup;
  @Input() public formValidationRequest$: Subject<void>;
  @Input() public toolName: AuditToolCommonNames;

  public get testingTool(): AuditToolNames {
    return AuditToolCommonNamesToAuditToolNames[this.toolName];
  }

  @Input() public monitoring: IDigitalPropertyMonitoringDetails;

  constructor(private readonly a11yStandardsService: A11yStandardsService) {
    this.$digitalPropertyMonitoring = $digitalPropertyMonitoring;
  }

  private initializeForm(): void {
    if (this.monitoring?.[$digitalPropertyMonitoring.conformanceLevel]) {
      this.form
        .get($digitalPropertyMonitoring.conformanceLevel)
        .setValue(this.monitoring[$digitalPropertyMonitoring.conformanceLevel]);
    }
    if (this.monitoring?.[$digitalPropertyMonitoring.viewport]) {
      this.form.get($digitalPropertyMonitoring.viewport).setValue(this.monitoring[$digitalPropertyMonitoring.viewport]);
    }
  }

  public ngOnInit(): void {
    this.a11yStandards$ = this.a11yStandardsService.getFilteredStandards();
  }

  ngAfterViewInit(): void {
    this.initializeForm();
  }
}
